import { faGlobe } from "@fortawesome/pro-solid-svg-icons/faGlobe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { MprcMultiLanguageInputDialog } from "components/MprcMultiLanguage";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";
import { useRef, useState } from "react";

interface IProps {
    locales: LocaleInput[];
    currentValues?: LocaleInputCollection,
    maxLength?: number;
    startAdorment?: React.ReactNode;
    placeholderFocus?: string;
    onInputRef?: (ref?: HTMLInputElement) => void;
    onLocaleInputChange?: (result?: LocaleInputCollection) => void;
    onLocaleDialogClose?: (result?: LocaleInputCollection) => void;
}

type Props = IProps & Omit<TextFieldProps, "onChange" | "value" | "InputProps" | "inputProps">;

export const MprcTextFieldMultiLanguage: React.FC<Props> = (props) => {

    const { theme } = useMprcTheme();
    const inputRef = useRef<HTMLInputElement>(undefined);

    const { locales, defaultValue, currentValues, maxLength, placeholderFocus, onLocaleInputChange, onLocaleDialogClose, onInputRef, error, startAdorment, ...textFieldProps } = props;

    const [openDialog, setOpenDialog] = useState(false);
    const [focus, setFocus] = useState<boolean>(false);

    const defaultLocale = locales.find(p => p.isDefault);
    if (defaultLocale == undefined) throw Error("Default locale not found.");

    const currentLangIndex = currentValues?.findIndex(p => p.locale == defaultLocale?.locale) ?? -1;
    if (currentLangIndex == -1) throw Error("Cannot find Default locale in current values.");

    const value = currentValues && currentValues.length > 0 ? currentValues[currentLangIndex].text : null;

    //////////////////////////////////////////////////////////////////////////////////////////

    const handleClose = (result?: LocaleInputCollection) => {
        onLocaleInputChange && onLocaleInputChange(result);
        setOpenDialog(false);
        onLocaleDialogClose && onLocaleDialogClose(result);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onLocaleInputChange && currentValues) {
            const newValue = [...currentValues];
            newValue[currentLangIndex].text = e.target.value;
            onLocaleInputChange(newValue);
        }
    };

    // Informa qual foi o INPUTREF utilizado no TextField.
    React.useEffect(() => {
        onInputRef && onInputRef(inputRef.current);
    }, []);

    return (
        <>
            {
                openDialog &&
                <MprcMultiLanguageInputDialog
                    maxLength={maxLength}
                    maxRows={textFieldProps.maxRows}
                    multiline={textFieldProps.multiline}
                    locales={locales}
                    defaultValue={inputRef?.current?.value}
                    currentValues={currentValues}
                    onClose={handleClose}
                />
            }
            <TextField
                {...textFieldProps}
                placeholder={placeholderFocus && focus ? placeholderFocus : textFieldProps.placeholder}
                value={value || ""}
                onChange={handleInputChange}
                error={error || (defaultLocale?.required && value?.length == 0 && props.required)}
                slotProps={{
                    input: {
                        inputRef: inputRef,
                        startAdornment: startAdorment ? <InputAdornment position='start'>{startAdorment}</InputAdornment> : undefined,
                        endAdornment: (
                            <FontAwesomeIcon
                                style={{ cursor: "pointer", color: "inherit", paddingLeft: "8px" }}
                                icon={faGlobe}
                                title={theme.MprcMultiLanguageInputDialog.title}
                                onClick={() => setOpenDialog(true)}
                            />),
                        inputProps: { maxLength: maxLength }
                    }
                }}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
            >
            </TextField>
        </>
    );
};
